import React, {useEffect, useState, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import actions from '../../../redux/actions';
import icSearch from '../../../images/ic_search.png';
import './AffiliateList.scss';

import TableHeader from '../../../common/components/ItemTable/TableHeader';
import TableRow from '../../../common/components/ItemTable/TableRow';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';

import Loading from '../../../common/components/Loading/Loading';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import NewAttentionModal from '../NewAttentionModal/NewAttentionModal';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const ViewAttentionsButton = (affiliate, setSelectedAffiliate) => {
    const history = useHistory();

    return (
        <Ebutton classNameButton="ul-btn"
            onClick={()=>{
                setSelectedAffiliate(affiliate);
                history.push('attentions');
            }}
            text=" Ver atenciones"
        />
    );
};

const AffiliatesList = ({
                        name,
                        title,
                        affiliates,
                        affiliatesListConfig,
                        getAffiliatesState,
                        getAffiliates,
                        setListConfig,
                        affiliateSearchRecomendations,
                        switchOfUser,
                        setSelectedAffiliate,
                        showSidebar,
}) => {
    const listData = [
        {title: 'NOMBRE', att: 'firstName'},
        {title: 'APELLIDO', att: 'lastName'},
        {title: 'DNI', att: 'dni'},
        {title: 'PLAN DE SALUD', att: 'plan'},
        {title: 'Nº AFILIADO', att: 'affiliateNumber'},
        {title: 'ESTADO', att: 'state'},
        // eslint-disable-next-line new-cap
        {title: '', component: (affiliate) => ViewAttentionsButton(affiliate, setSelectedAffiliate)},
    ];

    // const history = useHistory();

    // const [search, setSearch] = useState('');

    const [currentPage, setCurrentPage] = useState(-1);
    const pageQuantity = Math.ceil(affiliates?.total/affiliatesListConfig?.size);

    /*
    const pushPage = (name) => {
        history.push(name);
    };
    */

    const isInitialMount = useRef(true);

    useEffect(()=>{
        if ( !isInitialMount.current ) {
            setListConfig( {
                list: 'affiliatesListConfig',
                config: {page: currentPage},
            } );
            getAffiliates();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect( ()=>{
        if ( currentPage >= pageQuantity && pageQuantity>0 ) setCurrentPage( pageQuantity-1 );
        // eslint-disable-next-line
    }, [affiliates] );

    useEffect(() => {
        switchOfUser('Historial atenciones');
        setCurrentPage( affiliatesListConfig?.page ?? 1 );
        // eslint-disable-next-line
    }, []);

    /*
    const sortList = (param)=>{
        setListConfig( {
            list: 'adminListConfig',
            config: {orderBy: param},
        } );
        getUsers();
    };

    const handleSearch = () => {
        setListConfig( {
            list: 'adminListConfig',
            config: {search: search},
        } );
        getUsers();
    };
    */

    const [showModal, setShowModal] = useState(false);

    const handleNewAttention = () => {
        setShowModal(true);
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">

                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                    <form onSubmit={(event)=>{
                        event.preventDefault();
                        // handleSearch();
                    }} >
                    <div className="ul-div-serchCont">
                        <div className="ul-div-searchbar">
                            <input
                                list="affiliateSearchRecomendations"
                                placeholder="Afiliados / Prestadores"
                                // onChange =
                                // + setSearch
                                // + something that conditionaly* dispatches getRecommendations
                            />
                            <datalist id="affiliateSearchRecomendations">
                                {affiliateSearchRecomendations &&
                                 affiliateSearchRecomendations.map( (item, i)=>(
                                    <option key={i} value={item} />
                                ) ) }
                            </datalist>
                            <button type='submit'><img src={icSearch} alt={'search'}/></button>
                        </div>
                    </div>
                    </form>
                </div>

                <div className="ul-div-sect-table">
                    { getAffiliatesState?.success?
                        <table className="ul-div-table">
                            <TableHeader listData={listData} />
                            <tbody>
                            {
                                affiliates?.total <= 0 ?
                                <tr><td colSpan={100} ><CustomAlert text='administradores' /></td></tr> :
                                affiliates?.results && affiliates?.results.map((item, index) =>
                                    <TableRow key={index} listData={listData} data={item} />,
                                )
                            }
                            </tbody>
                        </table> :
                    getAffiliatesState?.loading?<Loading className="ul-div-sect-table" />:
                        <CustomAlert text={'afiliados' || String(getAffiliatesState?.error)} severity='error' />
                    }
                </div>

                <div className="ul-div-bottom">
                    <ListPaginator pageQuantity={pageQuantity} currentPage={affiliatesListConfig?.page} setCurrentPage={setCurrentPage} />
                    <Ebutton classNameButton="ul-btn" onClick={handleNewAttention} text="NUEVA ATENCION" />
                </div>

            </div>
            {showModal && (
                <NewAttentionModal
                    showModal={showModal}
                    handleClose={()=>setShowModal(false)}
                    handleClick={()=>setShowModal(false)}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
  name: localStorage.getItem('name'),
  title: state.home.title,
  affiliates: state.attentions.affiliates,
  affiliatesListConfig: state.attentions.affiliatesListConfig,
  getAffiliatesState: state.attentions.getAffiliatesState,
  affiliateSearchRecomendations: state.attentions.affiliateSearchRecomendations,
  showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
  switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
  getAffiliates: (body) => dispatch(actions.attentions.getAffiliates(body)),
  setListConfig: (body) => dispatch(actions.attentions.setListConfig(body)),
  setSelectedAffiliate: (selectedAffiliate) => dispatch(actions.attentions.setSelectedAffiliate(selectedAffiliate)),
});

AffiliatesList.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(AffiliatesList);
